import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	kpTitle: {
		id: 'b2b.landing.title.kp',
		defaultMessage: 'Thrive with Calm',
		description: 'Page title for Kaiser Permanente partnership',
	},
	defaultTitle: {
		id: 'b2b.landing.title.default',
		defaultMessage: 'Welcome to Calm',
		description: 'Default page title for B2B',
	},
	activateKpMessage: {
		id: 'b2b.landing.activate.kp',
		defaultMessage: 'Enjoy Calm Premium for Free',
		description: 'The type of membership the user will receive',
	},
	activateLincolnMessage: {
		id: 'b2b.landing.activate.lincoln',
		defaultMessage: 'Activate 1 Year of Calm Premium for Free',
		description: 'The type of membership the user will receive',
	},
	activateMessage: {
		id: 'b2b.landing.activate.defaultMessage',
		defaultMessage: '{partnerName} is offering you Calm Premium for free',
		description: 'The type of membership the user will receive',
	},
	offerMessage: {
		id: 'b2b.landing.offerMessage',
		defaultMessage: '{partnerName} is offering you a Calm Premium subscription',
		description: 'The type of membership the user will receive',
	},
	freeOfferMessage: {
		id: 'b2b.landing.freeOfferMessage',
		defaultMessage: '{partnerName} is offering you Calm Premium for free.',
		description: 'The type of membership the user will receive for free',
	},
	esteeOfferMessage: {
		id: 'b2b.landing.esteeOfferMessage',
		defaultMessage: 'Estée Lauder’s Advanced Night Repair serum is offering you a Calm Premium subscription',
		description: 'Custom offer message for Estee Lauder',
	},
	gladeTitle: {
		id: 'b2b.landing.title.glade',
		defaultMessage: 'Meet Calm, the #1{breakingLine}App for Meditation',
		description: 'Page title for Kaiser Permanente partnership',
	},
	gladeOfferMessage: {
		id: 'b2b.landing.gladeOfferMessage',
		defaultMessage: 'Start your free 90-day trial',
		description: 'Custom offer message for Glade',
	},
	gladeOfferSubheadMessage: {
		id: 'b2b.landing.gladeOfferSubheadMessage',
		defaultMessage:
			'Glade Aromatherapy is partnering with Calm to offer hundreds of hours of meditations, music, Sleep Stories, and more. Enjoy the moment, practice mindfulness combined with beautifully crafted fragrance to inspire your mood, your moment.',
		description: 'Custom offer message for Glade',
	},
	blueApronOfferMessage: {
		id: 'b2b.landing.blueApronOfferMessage',
		defaultMessage:
			'For a limited time, Blue Apron is offering{breakingLine}3-months of Calm Premium for free.',
		description: 'Custom offer message for Blue Apron',
	},
	nysutOfferMessage: {
		id: 'b2b.landing.nysutOfferMessage',
		defaultMessage: '{partnerName} is offering In-Service & Retiree Members Calm Premium for free.',
		description: 'Custom offer message for NYSUT',
	},
	resumeBuilderOfferMessage: {
		id: 'b2b.landing.resumeBuilderOfferMessage',
		defaultMessage: 'As a {partnerName} subscriber, you can enjoy Calm Premium for free.',
		description: 'Custom offer message for Resume Builder',
	},
	peacockOfferMessage: {
		id: 'b2b.landing.peacockOfferMessage',
		defaultMessage: 'For a limited time, Peacock is offering{breakingLine}3-months of Calm Premium for free.',
		description: 'Custom offer message for Peacock',
	},
	peacockUpdatedOfferMessage: {
		id: 'b2b.landing.peacockUpdatedOfferMessage',
		defaultMessage: 'For a limited time, redeem 3-months of Calm Premium for free.',
		description: 'Custom offer message for Peacock',
	},
	calmOfferMessage: {
		id: 'b2b.landing.calmOfferMessage',
		defaultMessage: 'Take a deep breath y’all',
		description: 'Custom offer message for Calm Employees',
	},
	optusOfferMessage: {
		id: 'b2b.landing.optusOfferMessage',
		defaultMessage: 'Congratulations! You are about to link a Calm Premium subscription to Optus SubHub',
		description: 'Custom offer message for Optus SubHub customers',
	},
	logitechOfferMessage: {
		id: 'b2b.landing.logitechOfferMessage',
		defaultMessage: 'Redeem your 3-months of Calm Premium for free from Logitech',
		description: 'Custom offer message for Logitech',
	},
	fitbitOfferMessage: {
		id: 'b2b.landing.fitbitOfferMessage',
		defaultMessage:
			'For a limited time, activate your Fitbit Premium membership when you purchase a new Sense advanced smartwatch on Fitbit.com to receive a 6-month subscription to Calm',
		description: 'Custom offer message for Fitbit',
	},
	comcastEmployees: {
		id: 'b2b.landing.comcastEmployees',
		defaultMessage: 'Comcast Employees',
		description: 'Custom SSO link label for Comcast Employees',
	},
	comcastNBCUEmployees: {
		id: 'b2b.landing.comcastNBCUEmployees',
		defaultMessage: 'NBCUniversal Employees',
		description: 'Custom SSO link label for Comcast NBCUniversal Employees',
	},
	comcastUOEmployees: {
		id: 'b2b.landing.comcastUOEmployees',
		defaultMessage: 'Universal Orlando Employees',
		description: 'Custom SSO link label for Comcast Universal Orlando Employees',
	},
	comcastActivate: {
		id: 'b2b.landing.comcastActivate',
		defaultMessage: 'Comcast NBCUniversal is offering you a Calm Premium subscription at no cost to you',
		description: 'Custom headline for Comcast',
	},
	comcastInstructions: {
		id: 'b2b.landing.comcastInstructions',
		defaultMessage: 'Enter your {uniqueId} to link your account and enable Calm Premium, at no cost to you!',
		description: 'Custom instructions for Comcast',
	},
	comcastLegal: {
		id: 'b2b.landing.comcastLegal',
		defaultMessage:
			'Calm is an external third party and as an employee of Comcast, when you access the Calm platform, you will need to agree to terms that are strictly between you and Calm directly.',
		description: 'Custom legal text for comcast',
	},
	prymInstructions: {
		id: 'b2b.landing.prymInstructions',
		defaultMessage:
			'Enter the {uniqueId} provided during your Calm registration to enable Calm Premium, free!',
		description: 'Custom instructions for Comcast',
	},
	prymError: {
		id: 'b2b.landing.prymError',
		defaultMessage:
			'You should use the Personal Email Address you provided during your Calm registration and allow up to 48 hours for your registration to be activated.',
		description: 'Custom error message for Prym',
	},
	prymHelp: {
		id: 'b2b.landing.prymHelp',
		defaultMessage: "If you're unsure of your {uniqueId}, <helplink>visit this help article</helplink>.",
		description: 'Custom help message for Prym',
	},
	gerberSuccessCopy: {
		id: 'partner.success.gerberSuccessCopy',
		defaultMessage:
			'You have access to <bold>Calm Premium!</bold>{breakingLine}We recommend downloading the Calm app and starting your journey there.{breakingLine}After downloading the app, {login} to unlock the premium content.{breakingLine}Find calm with our "For Parents" Collection',
		description: 'Custom success message for Gerber',
	},
	gerberSuccessCTA: {
		id: 'partner.success.gerberSuccessCTA',
		defaultMessage: 'Listen Now',
		description: 'Custom success call to action for Gerber',
	},
	singtel1mActivate: {
		id: 'b2b.landing.singtel1mActivate',
		defaultMessage: 'Singtel is offering you a 1 month Calm Premium subscription',
		description: 'Custom headline for Singtel 1m',
	},
	singtel3mActivate: {
		id: 'b2b.landing.singtel3mActivate',
		defaultMessage: 'Singtel is offering you a 3 month Calm Premium subscription',
		description: 'Custom headline for Singtel 3m',
	},
	singtel1yActivate: {
		id: 'b2b.landing.singtel1yActivate',
		defaultMessage: 'Singtel is offering you a 1 year Calm Premium subscription',
		description: 'Custom headline for Singtel 1y',
	},
	wakemedInstructions: {
		id: 'b2b.landing.wakemedInstructions',
		defaultMessage:
			'Enter the Personal Email you provided WakeMed Hospital to link your account and enable Calm Premium, free!',
		description: 'Custom instructions for WakeMed Health & Hospitals',
	},
	wakemedHelp: {
		id: 'b2b.landing.wakemedHelp',
		defaultMessage:
			"If you're unsure of the email you provided to WakeMed, please <helplink>contact Calm's Support team here</helplink>.",
		description: 'Custom help message for WakeMed Health & Hospitals',
	},
	coxEnterprisesLegal: {
		id: 'b2b.landing.coxEnterprises.legal',
		defaultMessage:
			'Cox users may be required to sign up and agree to separate user terms and conditions in order to use or access this program. Users accept separate terms of use and access this program at their own risk. Users accept and assume full responsibility and agree to be solely responsible for their safety and wellbeing. Cox Enterprises, Inc., along with any "Affiliates" (other company within the Cox Enterprises, Inc. corporate family) is not responsible or liable for information or services obtained. Please reach out to wellness@coxinc.com with any questions.',
		description: 'Custom legal message for Cox Enterprises',
	},
	eeActivate: {
		id: 'b2b.landing.eeActivate',
		defaultMessage: 'Thank you for choosing a Calm Premium subscription through EE.',
		description: 'Custom headline for EE partnership',
	},
});
